<span class="container-subtitle">Main Contract</span>
<div class="file-container" [ngClass]="{'warning': loadingGeneratedFile || showFileMenu || (!loadingGeneratedFile && !showFileMenu && fileType == 'upload' && !uploadedDoc), 'success': (!loadingGeneratedFile && !showFileMenu && fileType == 'generate' && generatedFileExists) || (!loadingGeneratedFile && !showFileMenu && fileType == 'upload' && uploadedDoc) || (!loadingGeneratedFile && !showFileMenu && fileType == 'template')}">
	<span class="right" *ngIf="!loadingGeneratedFile" (click)="showFileMenu = !showFileMenu">
		<i *ngIf="!showFileMenu" class="fas fa-angle-down expand"></i>
		<i *ngIf="showFileMenu" class="fas fa-angle-up expand"></i>
	</span>

	<!-- NOT EXPANDED - USE GENERATED PDF -->
	<div *ngIf="!showFileMenu && fileType == 'generate'" (click)="showFileMenu = !showFileMenu">
		<ng-container *ngIf="loadingGeneratedFile">
			<span><i class="fas fa-file-pdf"></i></span>
			<span class="text">Searching for PDF</span>
			<span class="text ellipsis-animate"></span>
		</ng-container>
		<ng-container *ngIf="!loadingGeneratedFile">
			<span><i class="fas fa-file-pdf"></i></span>
			<span class="text">Use generated PDF</span>
		</ng-container>
	</div>

	<!-- NOT EXPANDED - UPLOAD -->
	<div *ngIf="!showFileMenu && fileType == 'upload'" (click)="showFileMenu = !showFileMenu">
		<ng-container *ngIf="uploadedDoc">
			<span><i class="fas fa-upload"></i></span>
			<span class="text" [title]="uploadedDoc?.name">{{ uploadedDoc?.name }}</span>
		</ng-container>
		<ng-container *ngIf="!uploadedDoc">
			<span><i class="fas fa-file"></i></span>
			<span class="text">File not generated. Select a file.</span>
		</ng-container>
	</div>

	<!-- NOT EXPANDED - TEMPLATE -->
	<div *ngIf="!showFileMenu && fileType == 'template'" (click)="showFileMenu = !showFileMenu">
		<span><i class="fas fa-file-contract"></i></span>
		<span class="text" [title]="selectedTemplate.title">{{ selectedTemplate.title }}</span>
	</div>

	<!-- EXPANDED - USE GENERATED PDF -->
	<ng-container *ngIf="showFileMenu && generatedFileExists">
		<div class="file-select-row-top" (click)="selectFileType('generate')">
			<span><i class="fas fa-file-pdf"></i></span>
			<span class="text">Use generated PDF</span>
		</div>
	</ng-container>

	<!-- EXPANDED - UPLOAD -->
	<ng-container *ngIf="showFileMenu">
		<div *ngIf="!generatedFileExists && !uploadedDoc" class="file-select-row-top">
			<span><i class="fas fa-file"></i></span>
			<span class="text">File not generated. Select a file.</span>
		</div>
		<div [ngClass]="{'file-select-row-top': !generatedFileExists && uploadedDoc, 'file-select-row': generatedFileExists || !uploadedDoc }">
			<label for="file">
				<span><i class="fas fa-upload"></i></span>
				<span class="text">Browse for file</span>
				<input class="file-input" type="file" id="file" (change)="fileUploaded($event)">
			</label>
		</div>
		<div *ngIf="uploadedDoc" class="file-select-row" (click)="selectFileType('upload')">
			<span><i class="fas fa-upload"></i></span>
			<span class="text" [title]="uploadedDoc?.name">{{ uploadedDoc?.name }}</span>
		</div>
	</ng-container>

	<!-- EXPANDED - TEMPLATES -->
	<ng-container *ngIf="showFileMenu && contextService.clientDetailProcore.enableDropboxSignTemplates">
		<div class="file-select-row" *ngFor="let template of templates" (click)="setSelectedTemplate(template)">
			<span><i class="fas fa-file-contract"></i></span>
			<span class="text" [title]="template.title">{{ template.title }}</span>
		</div>
	</ng-container>
</div>